import { render, staticRenderFns } from "./Doctors.vue?vue&type=template&id=0e709683&scoped=true"
import script from "./Doctors.vue?vue&type=script&lang=js"
export * from "./Doctors.vue?vue&type=script&lang=js"
import style0 from "./Doctors.vue?vue&type=style&index=0&id=0e709683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e709683",
  null
  
)

export default component.exports